import {object, string} from "yup";

export const SubscriptionChangeFormValidator = object().shape({
    email: string().email('Voer een geldig email adres in!').required('Voer een email adres in!'),
})